





import Enumerable from "linq";
import { Mixins, Component } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../components/system";
import { FormatStructureEditableMixin } from "../../mixins";
import { IFormatAlert, FormatValidator as Validator } from "../../../../../domain/editableFormat";

@Component
export default class FormatValidator extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  async validate(shouldConfirm: boolean): Promise<boolean> {
    const alerts = this.findAlerts();
    const result = this.isRegisterable(alerts, shouldConfirm);
    this.alerts = alerts;
    await this.$nextTick();
    return result;
  }

  private findAlerts(): IFormatAlert[] {
    return (new Validator()).validate(this.editingSource);
  }

  async isRegisterable(alerts: IFormatAlert[], shouldConfirm: boolean) {
    const hasError = Enumerable.from(alerts).any(a => a.isError);
    const warningCount = Enumerable.from(alerts).count(a => !a.isError);
    const hasWarning = (0 < warningCount);
    return !hasError
    && (!hasWarning || !shouldConfirm || this.confirmToAllowWarning(warningCount));
  }
  
  async confirmToAllowWarning(warningCount: number): Promise<boolean> {
    try {
      const index = await this.$commonDialogs.confirmation.confirmYesNo(
        "登録確認",
        ["注意警告が" + warningCount + "件ありますが、そのまま登録しますか？"]
      );
      return (index === 0);
    } catch {
      return false;
    }
  }
}
